export const notificationSettings = {
  devStreamEventFcw: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventLdw: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventPcw: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventOverspeed: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventWireCut: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventDrowsiness: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventEyesOffRoad: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventCameraBlockageExteriorTotal: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventCameraBlockageExteriorPartial: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventCameraBlockageInteriorTotal: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventCameraBlockageInteriorPartial: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventMobilePhoneUsage: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventTailgaiting: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventAccidentCameraRemoval: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventHardBrake: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventHardAcceleration: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventHardTurn: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamEventHighG: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  devStreamDriverNotFound: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  drivingOvertime: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  driverUnauthorized: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  driverUnknown: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  learnFaceFail: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  learnFaceSuccess: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  learnFaceTimedOut: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  requestAvatarFail: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  requestAvatarSuccess: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  tripUpsertStart: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  tripUpsertStop: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  updateConfigFailed: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  updateConfigSuccess: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  videoUploadedFail: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  videoUploadedSuccess: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  alertVideoUploadedFail: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  alertVideoUploadedSuccess: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  intersectionsDirectionEntered: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
  intersectionsDirectionLeft: {
    notificationByWeb: true,
    notificationByEmail: false,
  },
};
